import {Preloader} from "components";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import CONSTANTS from "modules/utils/constants";
import React, {Fragment, useEffect, useState, type PropsWithChildren} from "react";
import {initReactI18next} from "react-i18next";

export const HOCi18n: React.FC<PropsWithChildren> = ({children}) => {
	const [initialized, setInitialized] = useState(false);
	useEffect(() => {
		void i18n.use(LanguageDetector)
			.use(Backend)
			.use(initReactI18next)
			.init(
				{
					returnNull: false,
					/**
					 * i18nextBrowserLanguageDetector
					 */
					debug: false,
					detection: {
						order: ["cookie", "localStorage", "sessionStorage", "navigator"],
					},
					supportedLngs: ["en"],
					backend: {
						crossDomain: true,
						loadPath: `${CONSTANTS.JSON_URL}locales/{{lng}}.json`,
					},
					fallbackLng: "en",
					keySeparator: ".",
					interpolation: {
						escapeValue: false,
						formatSeparator: ",",
					},
				},
				() => {
					console.info("Initialized");
				}
			)
			.finally(() => {
				if (CONSTANTS.SKIP_TRANSLATIONS) {
					void i18n.changeLanguage("cimode").finally(() => {
						setInitialized(true);
					});
				} else {
					setInitialized(true);
				}
			});
	}, []);

	return initialized ? <Fragment>{children}</Fragment> : <Preloader />;
};
